require('jquery-contextmenu');
require('./jquery-ui');
require('#js/jquery.hotkeys.js');
require('#js/jquery.simulate.js');
require('./jquery-extensoes');